import ContextRenderer from './context_renderer';

export default ContextRenderer;
